<template>
  <UiEditLayout class="mysearch-viewer">
    <template #tools="">
      <UiEditLayoutButton type="NEW_SEARCH" @click="emits('add')" />
      <UiEditLayoutButton type="COPY" @click="emits('copy')" :disabled="!cs" />
      <UiEditLayoutButton type="DELETE" @click="emits('delete')" :disabled="!cs" />
      <UiEditLayoutButton type="IMPORT" @click="emits('import')"  />
      <UiEditLayoutButton type="EXPORT" @click="emits('export')" :disabled="!cs" />
      <UiEditLayoutButton type="EDIT" @click="emits('edit')" :button-class="['is-primary', 'is-right']" />
    </template>
    <div class="search-main" v-if="cs && ss">
      <UiCsearchHeader :cs="cs" />
      <SearchBox :ss="ss" />
      <BaseContainerSpread>
        <UiItemSearchResult :ss="ss" :nonote="true" />
      </BaseContainerSpread>
    </div>
  </UiEditLayout>
</template>

<script lang="ts" setup>
const localSearchStore = useLocalSearchStore()
const csStore = useCsStore()
const { testCustomSearch } = useItem()

interface Props {
}
const props = withDefaults(defineProps<Props>(), {
})

const emits = defineEmits(['add', 'copy', 'delete', 'import', 'export', 'edit'])

const cs: Ref<CustomSearchDefinition> = ref(null)
const ss: Ref<SearchStore<Item>> = ref()

const watchActiveCs = async () => {
  try {
    if (localSearchStore.activeMySearch) {
      cs.value = (
        await csStore.getCs(localSearchStore.activeMySearch)
      ).cs
      ss.value = useSearch<Item>(
        cs.value,
        testCustomSearch(cs.value)
      )
      nextTick(() => {
        const query = fromQueryString(window.location.search)
        if (query.csid) {
          query.csid = cs.value.id
          ss.value.restoreQuery(query)
        }
      })
    } else {
      cs.value = null
      ss.value = null
    }
  } catch (e) {
    cs.value = null
    ss.value = null
  }
}

onBeforeMount(async () => {
  await watchActiveCs()
})

watch(
  () => localSearchStore.activeMySearch,
  () => {
    watchActiveCs()
  },
  { immediate: true },
)

const route = useRoute()
watch(
  () => route.query,
  () => {
    if (ss.value) {
      const query = fromQueryString(window.location.search)
      if (query.csid == localSearchStore.activeMySearch) {
        nextTick(() => {
          ss.value.restoreQuery()
        })
      } else {
        localSearchStore.activeMySearch = query.csid
      }
    }
  },
)
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.mysearch-viewer {
  .search-main {
    padding-top: 2rem;
    padding-bottom: 3rem;
    .jps-search-box {
      @include margin-full-width();
      margin-bottom: 1rem;
    }
    .item-search-result {
      @include margin-full-width();
    }
    > section {
      @include margin-full-width();
      margin-bottom: 3rem;
      .title {
        text-align: center;
      }
    }

    @include is-mobile() {
      padding-bottom: 1rem;
      .jps-search-box {
        padding-bottom: 1rem;
      }
    }
  }
}
</style>
